module.exports = __webpack_public_path__ + "static/img/0_1_1.a194a429.jpg";